const initialState = {
  transactions: [],
  page: 1,
  editing: false,
  filtersFormState: {
    data: {
      // sort: 'remainingValue',
    }
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'TOGGLE_TRANSACTION_EDIT': {
      return {
        ...state,
        editing: !state.editing,
      };
    }
    case 'TRANSACTION_UPDATED': {
      return {
        ...state,
        editing: false,
      };
    }
    case 'SET_TRANSACTIONS': {
      const { transactions, page } = payload;
      return {
        ...state,
        transactions,
        page,
      };
    }
    case 'TRANSACTIONS_FILTERS_CHANGE': {
      const { filtersFormState } = payload;
      return {
        ...state,
        filtersFormState,
        page: 1,
      };
    }
    case 'TRANSACTIONS_NEXT_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page + 1,
      };
    }
    case 'TRANSACTIONS_PREVIOUS_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page > 1 ? page - 1 : 1,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Transactions/Transactions.reducer.js